<mat-form-field class="{{ className }}">
	<mat-label>{{ label }}</mat-label>
	<mat-select [formControl]="elementCtrl" #singleSelect (selectionChange)="onElementSelected($event)">
		<app-mat-select-filter [formControl]="elementFilterCtrl" ngDefaultControl></app-mat-select-filter>

		@for (element of filteredElements | async; track element) {
			<mat-option [value]="element.id">
				{{ element.displayName }}
			</mat-option>
		}
	</mat-select>
</mat-form-field>
<!---->
